export default __webpack_public_path__ + "static/media/Git.1805a5b9.svg";